import { Tabs, TabsList, TabsTrigger, TabsContent } from "../ui/tabs";
import { EmailServices, SmsSettings } from "./Services";
import { TwilioEmailSettings, EmailActivity, EmailDomains } from "./TwilioEmail";
import { SharedDocuments } from "./SharedDocuments";
import { WebsiteEnquiries } from "./WebsiteEnquiries";
import { EmailTemplates } from "./EmailTemplates";
import { Announcements } from "./Announcements";

export function CommsCentre({ accounts }) {
  return (
    <Tabs defaultValue="announcements" data-testid="comms-centre">
      <TabsList className="mb-6">
        <TabsTrigger value="announcements" data-testid="comms-tab-announcements">Announcements</TabsTrigger>
        <TabsTrigger value="templates" data-testid="comms-tab-templates">Email Templates</TabsTrigger>
        <TabsTrigger value="email" data-testid="comms-tab-email">Email Services</TabsTrigger>
        <TabsTrigger value="activity" data-testid="comms-tab-activity">Email Activity</TabsTrigger>
        <TabsTrigger value="shared" data-testid="comms-tab-shared">Shared Documents</TabsTrigger>
        <TabsTrigger value="enquiries" data-testid="comms-tab-enquiries">Website Enquiries</TabsTrigger>
        <TabsTrigger value="sms" data-testid="comms-tab-sms">SMS</TabsTrigger>
      </TabsList>
      <TabsContent value="announcements"><Announcements accounts={accounts} /></TabsContent>
      <TabsContent value="templates"><EmailTemplates /></TabsContent>
      <TabsContent value="email" className="space-y-6"><TwilioEmailSettings scope="agency" /><EmailDomains /><EmailServices /></TabsContent>
      <TabsContent value="activity"><EmailActivity scope="agency" /></TabsContent>
      <TabsContent value="shared"><SharedDocuments scope="agency" /></TabsContent>
      <TabsContent value="enquiries"><WebsiteEnquiries /></TabsContent>
      <TabsContent value="sms"><SmsSettings /></TabsContent>
    </Tabs>
  );
}
